import AuthLayout from '@/layouts/AuthLayout';
import { LoginContent } from '@/pages/auth/LoginContent';
import { SignupCode } from '@/pages/auth/SignupCode';
import { SignupContent } from '@/pages/auth/SignupContent';

import { AnonymousRoute, AuthenticatedRoute } from '../allauth_auth/routing';
import AuthenticateTOTP from '../pages/auth/AuthenticateTOTP';
import ChangePassword from '../pages/auth/ChangePassword';
import ConfirmLoginCode from '../pages/auth/ConfirmLoginCode';
import ConfirmPasswordResetCode from '../pages/auth/ConfirmPasswordResetCode';
import LogoutPage from '../pages/auth/Logout';
import ProviderCallback from '../pages/auth/ProviderCallback';
import ProviderSignup from '../pages/auth/ProviderSignup';
import RequestLoginCode from '../pages/auth/RequestLoginCode';
import RequestPasswordReset from '../pages/auth/RequestPasswordReset';
import {
  ResetPasswordByCode,
  ResetPasswordByLink,
  resetPasswordByLinkLoader,
} from '../pages/auth/ResetPassword';
import TOTPManage from '../pages/auth/TOTPManage';
import TOTPSetup from '../pages/auth/TOTPSetup';
import VerifyEmail, {
  loader as verifyEmailLoader,
} from '../pages/auth/VerifyEmail';
import VerifyEmailCode from '../pages/auth/VerifyEmailCode';

export const authRoutes = [
  {
    path: '/account/login',
    element: (
      <AuthLayout title='Log in'>
        <LoginContent />
      </AuthLayout>
    ),
  },
  {
    path: '/signup/code',
    element: (
      <AuthLayout title='Sign up'>
        <SignupCode />
      </AuthLayout>
    ),
  },
  {
    path: '/account/signup',
    element: (
      <AuthLayout title='Sign up'>
        <SignupContent />
      </AuthLayout>
    ),
  },
  {
    path: '/account/login/otp',
    element: (
      <AnonymousRoute>
        <AuthenticateTOTP />
      </AnonymousRoute>
    ),
  },
  {
    path: '/account/logout',
    element: <LogoutPage />,
  },
  {
    path: '/account/verify-email',
    element: <VerifyEmailCode />,
  },
  {
    path: '/account/verify-email/:key',
    element: <VerifyEmail />,
    loader: verifyEmailLoader,
  },
  {
    path: '/account/provider/callback',
    element: <ProviderCallback />,
  },
  {
    path: '/account/provider/signup',
    element: (
      <AnonymousRoute>
        <ProviderSignup />
      </AnonymousRoute>
    ),
  },
  {
    path: '/account/login/code',
    element: (
      <AnonymousRoute>
        <RequestLoginCode />
      </AnonymousRoute>
    ),
  },
  {
    path: '/account/login/code/confirm',
    element: (
      <AnonymousRoute>
        <ConfirmLoginCode />
      </AnonymousRoute>
    ),
  },
  {
    path: '/account/password/reset',
    element: (
      <AnonymousRoute>
        <RequestPasswordReset />
      </AnonymousRoute>
    ),
  },
  {
    path: '/account/password/reset/confirm',
    element: (
      <AnonymousRoute>
        <ConfirmPasswordResetCode />
      </AnonymousRoute>
    ),
  },
  {
    path: '/account/password/reset/complete',
    element: (
      <AnonymousRoute>
        <ResetPasswordByCode />
      </AnonymousRoute>
    ),
  },
  {
    path: '/account/password/reset/key/:key',
    element: (
      <AnonymousRoute>
        <ResetPasswordByLink />
      </AnonymousRoute>
    ),
    loader: resetPasswordByLinkLoader,
  },
  {
    path: '/account/password/change',
    element: (
      <AuthenticatedRoute>
        <ChangePassword />
      </AuthenticatedRoute>
    ),
  },
  {
    path: '/account/authenticators/totp',
    element: (
      <AuthenticatedRoute>
        <TOTPSetup />
      </AuthenticatedRoute>
    ),
  },
  {
    path: '/account/authenticators',
    element: (
      <AuthenticatedRoute>
        <TOTPManage />
      </AuthenticatedRoute>
    ),
  },
];
